export default {
  "root": "_root_2lip1_1",
  "--bleed": "_--bleed_2lip1_1",
  "--bleed-true--m": "_--bleed-true--m_2lip1_1",
  "--bleed-false--m": "_--bleed-false--m_2lip1_1",
  "--bleed-true--l": "_--bleed-true--l_2lip1_1",
  "--bleed-false--l": "_--bleed-false--l_2lip1_1",
  "--bleed-true--xl": "_--bleed-true--xl_2lip1_1",
  "--bleed-false--xl": "_--bleed-false--xl_2lip1_1"
};import "ni:sha-256;guti23WWT4Ss4qBiePPbd6wi916TwEQyOngmSoBTSKk";